// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import Link from '@root/components/Link';
import PdfSvg from '@static/img/icons/pdf.svg';
import styles from './TosSection.module.scss';

const TosSection: PageComponent = () => {
    // TODO: check responsive
    return (
        <section className={styles.section}>
            <div className={styles.background_diamonds_sides}>
                <div className={styles.tos_container}>
                    <div className={styles.tos_inner}>
                        <Link
                            href="landing_information_privacy_policy"
                        >
                            <a>
                                <div className={styles.tos_inside}>
                                <PdfSvg />
                                    <span>
                                        <Trans
                                            i18nKey="privacyPolicy"
                                            ns="landingHelpFaq"
                                        >
                                            Privatumo politika
                                        </Trans>
                                    </span>
                                </div>
                            </a>
                        </Link>
                    </div>
                    <div className={styles.tos_inner}>
                        <Link
                            href="landing_information_term_of_service"
                        >
                            <a>
                                <div className={styles.tos_inside}>
                                <PdfSvg />
                                    <span>
                                        <Trans
                                            i18nKey="TermsOfService"
                                            ns="landingHelpFaq"
                                        >
                                            Paslaugų teikimo sąlygos
                                        </Trans>
                                    </span>
                                </div>
                            </a>
                        </Link>
                    </div>
                    <div className={styles.tos_inner}>
                        <Link
                            href="landing_information_refund_policy"
                        >
                            <a>
                                <div className={styles.tos_inside}>
                                <PdfSvg />
                                    <span>
                                        <Trans
                                            i18nKey="refundPolicy"
                                            ns="landingHelpFaq"
                                        >
                                            Paslaugų grąžinimo politika
                                        </Trans>
                                    </span>
                                </div>
                            </a>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TosSection;
